import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDealByIdQuery } from 'api';

export const useContactPersons = () => {
  const { id } = useParams() as { id: string };
  const { data: dealDetails = {}, isLoading } = useDealByIdQuery({ id });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [expandedPersons, setExpandedPersons] = useState<Set<string>>(new Set());

  const onDrawerOpen = useCallback((contact?: any) => {
    setSelectedContact(contact || null);
    setOpenDrawer(true);
  }, []);

  const onDrawerClose = useCallback(() => {
    setOpenDrawer(false);
    setSelectedContact(null);
  }, []);

  const toggleExpandPerson = useCallback((personId: string) => {
    setExpandedPersons((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(personId)) {
        newSet.delete(personId);
      } else {
        newSet.add(personId);
      }
      return newSet;
    });
  }, []);

  const isPersonExpanded = useCallback(
    (personId: string) => {
      return expandedPersons.has(personId);
    },
    [expandedPersons]
  );

  // Process the client data from the deal
  const client = dealDetails?.client || {};

  // Process the contact persons data from the deal
  const contactPersons = client?.contactPersonList || [];

  // Format contact persons to match the expected structure
  const formattedContactPersons = contactPersons.map((person: any) => ({
    id: person.id,
    fullName: person.fullName,
    firstName: person.fullName?.split(' ')[0] || '',
    lastName: person.fullName?.split(' ').slice(1).join(' ') || '',
    department: person.department,
    role: person.role,
    language: {
      id: person.languageId,
      name: '', // Language name might need to be fetched from another source
    },
    emails: person.contacts?.EMAIL?.map((email: string) => ({ email })) || [],
    phones: person.contacts?.MOBILE?.map((phone: string) => ({ phone })) || [],
    contacts: person.contacts || {},
  }));

  return {
    onDrawerOpen,
    dealDetails,
    onDrawerClose,
    openDrawer,
    selectedContact,
    toggleExpandPerson,
    isPersonExpanded,
    clientDetails: client,
    contactPersons: formattedContactPersons,
    isLoading,
  };
};
